import CloudCardOne from "../../../assets/svg/hybrid-one.svg";
import CloudCardTwo from "../../../assets/svg/hybrid-two.svg";
import CloudCardThree from "../../../assets/svg/hybrid-three.svg";

export const cloudCardItems = [
  {
    id: 1,
    title: "Remote Management Connector",
    imageLeft: true,
    sectionBg: "#f8f8f8",
    textAlign: "left",
    imageMaxWidth: "590px",
    paragraphs: [
      "Dealers need access to simplify set up, on going configuration support and deliver agreed upon SLA and system services. End users want to co manage the system with the flexibility of not having to be in the facility or with specific computers.",
      "The economic engine of our industry is driven by month charged services. The goal of RMC is to deliver a suite of services that maximizes the (ROI) on the client's initial investment while providing capabilities to lower indirect costs of systems use (Low TCO)",
      "Today's contracts values are sold at a 35X",
      "Every sales should a service contract",
      "RMC offer a suite of services that provide tangible enhancements to each technology deployment.",
    ],
    image: CloudCardOne,
  },
  {
    id: 2,
    title: "Hosted RMC Server",
    imageLeft: false,
    sectionBg: "#ffffff",
    textAlign: "right",
    imageMaxWidth: "218px",
    paragraphs: [
      "One or Many : Designed For scale securely connect to and remotely manage thousands of sites. Secure HTTPS Tunneling Technology—Foundational connectivity technology that securely links systems to RMC server. Features:",
      "Logging in and clicking link initiates a hyperlink to remote systems Secure HTTPS connection to the client",
      "The RMC server creates a secure, bonded and encrypted connection initiated from inside the firewall",
      "Maintain, configure user-role management Identical user experience as if logged onto the Neptune 2.0 System over the primary network",
      "All system data is still maintained at the Edge – System integrity is strong Customer owns the system and data. Foundational Layer for Services Platform Modules",
    ],
    image: CloudCardTwo,
  },
  {
    id: 3,
    title: "Hybrid Central Management via Cloud",
    imageLeft: true,
    sectionBg: "#f8f8f8",
    textAlign: "left",
    imageMaxWidth: "477px",
    paragraphs: [
      "Dealers need access to simplify set up, on going configuration support and deliver agreed upon SLA and system services. End users want to co manage the system with the flexibility of not having to be in the facility or with specific computers.",
      'Remote Management Connector "RMC" links systems via SSL connection to Cloud for a direct link to field deployed system',
      "Best of both worlds with on-line and remote access to your systems",
      "The system and data is maintained at the edge",
      "Customers maintain 100% control",
      "Environment conditions selects option for management – Client owns the system and is not dependent on cloud 100%",
    ],
    image: CloudCardThree,
  },
];
